import React from 'react';
import './index.scss';
import { withViewPort } from '../../hooks/useViewport';

class ToolTip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayData: {}
    };
  }

  componentDidMount() {
    const el = document.body;
    el.addEventListener('click', this.eventListenerFn, false);
  }

  componentWillUnmount() {
    const el = document.body;
    el.removeEventListener('click', this.eventListenerFn, false);
  }

  eventListenerFn = event => {
    if (
      !(
        event.target.getAttribute('class') &&
        event.target.getAttribute('class').indexOf('tooltip') > -1
      )
    ) {
      const { id } = this.props;
      this.hideToolTip(id);
    }
  };

  showToolTip = id => {
    this.setState({
      displayData: {
        [id]: true
      }
    });
  };

  hideToolTip = id => {
    this.setState({
      displayData: {
        [id]: false
      }
    });
  };

  mouseClick = id => {
    const { displayData } = this.state;
    const isOpen = displayData[id];
    this.setState({
      displayData: {
        [id]: !isOpen
      }
    });
  };

  render() {
    const {
      position,
      children,
      content,
      color,
      id,
      name,
      isMobile
    } = this.props;
    const { displayData } = this.state;
    return (
      <div
        className="tooltip"
        onMouseEnter={() => {
          if (!isMobile) this.showToolTip(id);
        }}
        onMouseLeave={() => {
          if (!isMobile) this.hideToolTip(id);
        }}
        role="presentation"
        onClick={() => {
          if (isMobile) this.mouseClick(id);
        }}
      >
        <div className="tooltip__child">{children}</div>

        {displayData[id] && (
          <div
            className={`${
              name ? 'tooltip__image12' : 'tooltip__image'
            } ${position} ${color}`}
          >
            {content}
          </div>
        )}
      </div>
    );
  }
}

export default withViewPort(ToolTip);
